import { render } from "./Widget12.vue?vue&type=template&id=d322cb46&scoped=true&ts=true"
import script from "./Widget12.vue?vue&type=script&lang=ts"
export * from "./Widget12.vue?vue&type=script&lang=ts"

import "./Widget12.vue?vue&type=style&index=0&id=d322cb46&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d322cb46"]])

export default __exports__